<template>
      <g width="150px" height="160px">
        <g transform="scale(0.70)">
            <text class="name"
                @click="displayValueBox"
                style="transform:translate(60px, 40px)">{{ '콘덴서(' + attr.farad + 'μF)' }}</text>
        </g>
        <g transform="scale(0.50)">

            <linearGradient id="SVGID_7_1" gradientUnits="userSpaceOnUse" x1="158.4727" y1="174.2635" x2="163.5686"
                y2="174.2635">
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="1.868180e-08" style="stop-color:#EDEDED" />
                <stop offset="5.778535e-08" style="stop-color:#CECECE" />
                <stop offset="1.020835e-07" style="stop-color:#B2B2B2" />
                <stop offset="1.521744e-07" style="stop-color:#9C9C9C" />
                <stop offset="2.106337e-07" style="stop-color:#8B8B8B" />
                <stop offset="2.829547e-07" style="stop-color:#808080" />
                <stop offset="3.843944e-07" style="stop-color:#797979" />
                <stop offset="6.659737e-07" style="stop-color:#777777" />
                <stop offset="0.1529" style="stop-color:#979392" />
                <stop offset="0.332" style="stop-color:#A3A2A2" />
                <stop offset="0.4162" style="stop-color:#A0A0A1" />
                <stop offset="0.571" style="stop-color:#9D9D9E" />
                <stop offset="0.6867" style="stop-color:#949494" />
                <stop offset="0.7898" style="stop-color:#848484" />
                <stop offset="0.8854" style="stop-color:#6D6D6E" />
                <stop offset="0.9751" style="stop-color:#505051" />
                <stop offset="1" style="stop-color:#474747" />
            </linearGradient>
            <rect x="158.47" y="142.21" class="st0" width="5.1" height="64.11" />

            <linearGradient id="SVGID_7_2" gradientUnits="userSpaceOnUse" x1="574.5136" y1="173.8526" x2="579.6095"
                y2="173.8526" gradientTransform="matrix(-1 0 0 1 697.3948 0)">
                <stop offset="0" style="stop-color:#FFFFFF" />
                <stop offset="1.868180e-08" style="stop-color:#EDEDED" />
                <stop offset="5.778535e-08" style="stop-color:#CECECE" />
                <stop offset="1.020835e-07" style="stop-color:#B2B2B2" />
                <stop offset="1.521744e-07" style="stop-color:#9C9C9C" />
                <stop offset="2.106337e-07" style="stop-color:#8B8B8B" />
                <stop offset="2.829547e-07" style="stop-color:#808080" />
                <stop offset="3.843944e-07" style="stop-color:#797979" />
                <stop offset="6.659737e-07" style="stop-color:#777777" />
                <stop offset="0.1529" style="stop-color:#979392" />
                <stop offset="0.332" style="stop-color:#A3A2A2" />
                <stop offset="0.4162" style="stop-color:#A0A0A1" />
                <stop offset="0.571" style="stop-color:#9D9D9E" />
                <stop offset="0.6867" style="stop-color:#949494" />
                <stop offset="0.7898" style="stop-color:#848484" />
                <stop offset="0.8854" style="stop-color:#6D6D6E" />
                <stop offset="0.9751" style="stop-color:#505051" />
                <stop offset="1" style="stop-color:#474747" />
            </linearGradient>
            <polygon class="st1 pointer" points="117.79,205.91 122.88,205.91 122.88,141.8 117.79,141.8" />
            <path class="st2" d="M159.86,125.44c5.89-5.01,9.63-12.46,9.63-20.79c0-15.07-12.22-27.29-27.29-27.29s-27.29,12.22-27.29,27.29
  c0,7.15,2.75,13.65,7.25,18.51c-0.13,0.2-0.23,0.42-0.29,0.66l-4.03,17.22c-0.27,1.17,0.45,2.34,1.62,2.61l1.13,0.26
  c1.14,0.27,2.3-0.41,2.59-1.54c0.68-2.61,3.2-7.19,12.3-10.84c0.24-0.1,0.45-0.19,0.66-0.29c1.95,0.44,3.97,0.68,6.05,0.68
  c1.34,0,2.65-0.1,3.93-0.29c8.88,3.63,11.37,8.14,12.04,10.73c0.29,1.13,1.45,1.8,2.59,1.54l1.13-0.26
  c1.17-0.27,1.89-1.44,1.62-2.61L159.86,125.44z" />
            <circle :id="pincode + 'PS'" class="pin-cover terminal snap res_plus" @click="onClick(`${pincode}PS`)" cx="120" cy="210" r="6" />
            <circle :id="pincode + 'MS'" class="pin-cover terminal snap res_minus" @click="onClick(`${pincode}MS`)" cx="160" cy="210" r="6" />
        </g>
      </g>
</template>

<script>
import store from '../../../../store/index.js'
import { pins } from '../../../../mixins/pin-util.js'

export default {
  props: ['data'],
  mixins: [pins],
  name: 'Capacitor',
  data () {
    return {
      code: '',
      attr: {
        farad: 1,
      }
    }
  },
  mounted () {
    this.setPindata(this.data)
    this.code = this.namecode
  },
  computed: {
    values () {
      const data = store.state.sim.data
      if (data) return data.CP[Number(this.number)]
      return { volt: 0, amper: 0, resist: 0 }
    }
  },
  methods: {
    displayValueBox () {
      window.event.stopPropagation()
      store.state.valuebox.values.toggle = false
      store.commit('setValueBox', { type: 'values', toggle: true, id: this.data.id, 
        unit: 'farad',
        code: 'CP' })
    },
    onClick (pin) {
      console.log('where is data?: ' + JSON.stringify(this.data))
      const name = this.data.id
      store.commit('wire/createLines', { name, pin })
      window.event.stopPropagation()
    }
  }

}
</script>

<style lang="scss" scoped>
.selected {
  .st0, .st1, .st2 {
      stroke-width: 4px;
      stroke: #ff6f61;
  }
}
.res_plus:hover,
.res_minus:hover {
  cursor: pointer;
  fill: #e60012;
}
  .st0{fill:#000;}
  .st1{fill:#000;}
  .st2{fill:#874631;}
</style>
